import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function validEmailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) return null;

    const regexp = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const valid = regexp.test(control.value);
    if (control.value === '' || valid) {
      return null;
    }
    return { invalidEmail: true };
  };
}

@Directive({
  selector: '[appValidEmail]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidEmailValidatorDirective,
      multi: true,
    },
  ],
})
export class ValidEmailValidatorDirective {}
